import {
  type Dispatch,
  type SetStateAction,
  useCallback,
  useMemo,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
  type SelectedFilters,
  SelectedFiltersSchema,
} from '@/warranty-v3/entities/filters';

export function useSelectedFilters(): [
  SelectedFilters,
  Dispatch<SetStateAction<SelectedFilters>>,
] {
  const history = useHistory();
  const location = useLocation();

  const selectedFilters = useMemo<SelectedFilters>(
    function () {
      const searchParams = Object.fromEntries(
        new URLSearchParams(location.search).entries(),
      );

      return SelectedFiltersSchema.parse(searchParams);
    },
    [location.search],
  );

  const setSelectedFilters = useCallback(
    function (update: SetStateAction<SelectedFilters>) {
      const newSelectedFilters =
        typeof update === 'function' ? update(selectedFilters) : update;

      const newSearchParams = new URLSearchParams(location.search);

      for (const [key, value] of Object.entries(newSelectedFilters)) {
        if (!value) {
          newSearchParams.delete(key);
        } else {
          newSearchParams.set(key, value);
        }
      }

      history.replace({ ...location, search: newSearchParams.toString() });
    },
    [history, location, selectedFilters],
  );

  return [selectedFilters, setSelectedFilters];
}
